import dayjs from 'dayjs';

// Weight inputs (MT) accept 3 decimals — matches the decimal(12,3) columns and the
// values Recalculate writes (e.g. 29.887). A 0.01 step made the browser reject them.
export const WEIGHT_INPUT_STEP = '0.001';

export const getForecastMonthLabels = (period) => {
  if (!period) return ['M+1', 'M+2', 'M+3'];
  const base = dayjs(period, 'MMM-YYYY');
  if (!base.isValid()) return ['M+1', 'M+2', 'M+3'];
  return [1, 2, 3].map((i) => base.add(i, 'month').format('MMM-YY'));
};

// Release date shown for a grid row that stands for one or more monthly rows:
// the earliest of their own dates, the project-level date only when none has one.
// Dates are ISO (YYYY-MM-DD), so string order is date order.
export const earliestExpectedDate = (months, fallback = null) => {
  const dates = (months || [])
    .map((m) => (m?.expected_release_date ? String(m.expected_release_date).slice(0, 10) : null))
    .filter(Boolean)
    .sort();

  return dates[0] || fallback || null;
};

// Planning grid, project view: one row aggregates a project's buildings in a
// month. Show the earliest building release date, formatted like the API's
// expected_finish ("05 Oct 2026"); rows without one keep the API's fallback.
export const earliestReleaseLabel = (rows) => {
  const earliest = earliestExpectedDate(rows);
  if (earliest) return dayjs(earliest).format('DD MMM YYYY');
  return rows?.[0]?.expected_finish || '';
};

// "Dear ..." name for a forecast email — every recipient, not just the first one:
// ['mih@pebsteel.com.vn', 'ngd@pebsteel.com.vn'] → 'MIH/NGD'.
// Mirrors the mailers, which join the local parts the same way when the body is
// generated server-side (see Crm::ReleaseForecast::PlanningMailer).
export const recipientGreeting = (emails, fallback = 'All') => {
  const names = (emails || [])
    .map((email) => String(email || '').split('@')[0].trim().toUpperCase())
    .filter(Boolean);

  return names.length ? names.join('/') : fallback;
};

export const groupSalesUnitsByRegion = (units) => {
  if (!units?.length) return [];
  const grouped = {};
  units.forEach((u) => {
    const region = u.region || 'Other';
    if (!grouped[region]) grouped[region] = [];
    grouped[region].push({ value: u.id, label: `${u.name} - ${u.description}` });
  });
  return Object.keys(grouped).sort().map((r) => ({ label: r, options: grouped[r] }));
};

export const wFmt = (p) => {
  const v = parseFloat(p.value);
  return v > 0 ? v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '—';
};

// Month color scheme helper
export const getMonthColorStyles = (monthIndex) => {
  const headerColors = ['#dbeafe', '#dcfce7', '#fef3c7'];
  const cellColors = ['#f0f9ff', '#f0fdf4', '#fffbeb'];
  return {
    headerStyle: { backgroundColor: headerColors[monthIndex] },
    cellStyle: { backgroundColor: cellColors[monthIndex] },
  };
};